import AdasIcon from "@mui/icons-material/BlurOn";
import { Create, Datagrid, Edit, List, required, Resource, SaveButton, TextField, TextInput } from "react-admin";
import { CloneIconButton } from "../buttons/CloneIconButton";
import { BackofficeListTitle } from "../misc/BackofficeListTitle";
import { BackofficeRecordTitle } from "../misc/BackofficeRecordTitle";
import { Form2 } from "../misc/Form2";
import { Column } from "../misc/Column";
import { overviewCardStyle } from "../misc/backofficeTheme";
import { Row } from "../misc/Row";
import { type Adas } from "../providers/adasProvider";
import { CreateRecordButton } from "../buttons/CreateRecordButton";
import { SearchFilterInput } from "../inputs/SearchFilterInput";

const filters = [<SearchFilterInput key="q" source="q" alwaysOn resettable />];

function AdasList() {
  return (
    <List
      title={<BackofficeListTitle />}
      filters={filters}
      sort={/* initial sort order: */ { field: "name", order: "ASC" }}
      exporter={false}
      actions={<CreateRecordButton />}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false} sx={{ "& td:last-child": { width: "1px" } }}>
        <TextField label="Name" source="name" />
        <TextField label="Beschreibung" source="description" />
        <CloneIconButton />
      </Datagrid>
    </List>
  );
}

function AdasCreate() {
  return (
    <Create title={<BackofficeRecordTitle />}>
      <AdasForm mode="create" />
    </Create>
  );
}

function AdasEdit() {
  return (
    <Edit mutationMode="pessimistic" title={<BackofficeRecordTitle />}>
      <AdasForm mode="edit" />
    </Edit>
  );
}

function AdasForm({ mode }: { mode: "create" | "edit" }) {
  return (
    <Form2 warnWhenUnsavedChanges>
      <Column sx={{ padding: overviewCardStyle.padding }}>
        <TextInput label="Name" source="name" fullWidth autoFocus={mode === "create"} validate={required()} />
        <TextInput label="Beschreibung" source="description" fullWidth validate={required()} />
        <Row>
          <SaveButton icon={<></>} />
        </Row>
      </Column>
    </Form2>
  );
}

export const adasResource = (
  <Resource
    key="adas"
    name="adas"
    icon={AdasIcon}
    list={AdasList}
    create={AdasCreate}
    edit={AdasEdit}
    options={{ label: "Assistenzsysteme", createTitle: "Neues Assistenzsystem" }}
    recordRepresentation={(adas: Adas) => adas.name}
  />
);
